import React from "react";

const TextInputIcon = ({
  label,
  name,
  type = "text",
  required = false,
  register,
  errors,
  placeholder = "",
  defaultValue = "",
  icon = null,
  iconPosition = "right",
  inlineLabel = false,
  labelClass = "bg-white text-xs text-gray-500 z-10",
}) => {
  return (
    <div className="flex flex-col gap-2">
      <div className="relative gap-4 flex flex-col">
        {(label || inlineLabel) &&
          (inlineLabel ? (
            <label
              htmlFor={name}
              className={`absolute -top-[8px] left-4 ${labelClass}`}
            >
              {label} {required && <span className="text-red-500">*</span>}
            </label>
          ) : (
            <label htmlFor={name} className={`${labelClass}`}>
              {label} {required && <span className="text-red-500">*</span>}
            </label>
          ))}

        <div
          className={`relative flex items-center border rounded-lg px-4 py-2 transition-all focus-within:border-blue-300 focus-within:ring-2 focus-within:ring-blue-200 ${
            errors?.[name]
              ? "border-red-500 focus-within:border-red-300 focus-within:ring-red-200"
              : "border-border-color"
          }`}
        >
          {icon && iconPosition === "left" && (
            <span className="text-gray-500">{icon}</span>
          )}

          <input
            id={name}
            type={type}
            placeholder={placeholder}
            defaultValue={defaultValue}
            {...register(name, { required })}
            className="w-full focus:outline-none"
          />

          {icon && iconPosition === "right" && (
            <span className="text-gray-500">{icon}</span>
          )}
        </div>
      </div>

      {errors?.[name] && (
        <p className="text-red-500 text-xs">{errors[name]?.message}</p>
      )}
    </div>
  );
};

export default TextInputIcon;
